import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';

const BASE_URL = NAMESPACES.menu_api.brands;

// Función auxiliar para configurar la instancia de Axios
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));


// /GetAllBrandsByLocalId/<int:local_id>

export const getAllBrandsByLocalId = (local_id: number) => {
  return retryWithBackoff(() => api.get(`/GetAllBrandsByLocalId/${local_id}`));
};

/**
 * Crea una nueva marca.
 * @param data - Objeto que contiene los datos necesarios para crear la marca.
 * @returns Una promesa con la respuesta de la API.
 */
export const CreateBrand = (data: {
  brand_name: string;
  local_id: number;
}) => {
  return retryWithBackoff(() => api.post('/CreateBrand', data));
}

/**
 * Asocia una marca a un ingrediente.
 * @param data - Objeto que contiene el ID del ingrediente y el ID de la marca.
 * @returns Una promesa con la respuesta de la API.
 */
export const AssociateBrandToIngredient = (data: {
    ingredient_id: number;
    brand_id: number;
}) => {
  return retryWithBackoff(() => api.post('/AssociateBrandToIngredient', data));
}

/**
 * Elimina una marca por su ID.
 * @param brand_id - El ID de la marca a eliminar.
 * @returns Una promesa con la respuesta de la API.
 */

export const DeleteBrand = (brand_id: number) => {
  return retryWithBackoff(() => api.delete(`/DeleteBrand/${brand_id}`));
}


